import { MARK_DOT, MARK_FRAME_PATH, WORDMARK_AI_PATH, WORDMARK_PATH } from '@epc/brand';

/** Знак: рамка визира и точка «где проект сейчас» */
export function LogoMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden>
      <path d={MARK_FRAME_PATH} fill="none" stroke="currentColor" strokeWidth={9} />
      <circle cx={MARK_DOT.cx} cy={MARK_DOT.cy} r={MARK_DOT.r} fill="var(--color-accent)" />
    </svg>
  );
}

/** Полный логотип: знак и надпись EPC Pilot AI */
export function Logo({ height = 28, className }: { height?: number; className?: string }) {
  const width = Math.round((height * 541.7) / 100);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 541.7 100"
      className={className}
      role="img"
      aria-label="EPC Pilot AI"
    >
      <path d={MARK_FRAME_PATH} fill="none" stroke="currentColor" strokeWidth={9} />
      <circle cx={MARK_DOT.cx} cy={MARK_DOT.cy} r={MARK_DOT.r} fill="var(--color-accent)" />
      <path d={WORDMARK_PATH} fill="currentColor" />
      <path d={WORDMARK_AI_PATH} fill="var(--color-accent)" />
    </svg>
  );
}
